import ReactModal from 'react-modal';
import { isMobile } from 'react-device-detect';


export default function Modal({
  title,
  body,
  footer,
  isOpenOverride,
  ...props
}: Omit<ReactModal.Props, 'isOpen'> & {
  title: string;
  isOpenOverride?: boolean;
  body?: React.ReactNode;
  footer?: React.ReactNode;
}) {

  return (
    <ReactModal
      {...props}
      isOpen={isOpenOverride ?? true}
      appElement={document.getElementById('root') as HTMLElement}
      style={{
        overlay: {
          zIndex: 100000,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        content: {
          display: "flex",
          flexDirection: "column",
          inset: "auto",
          ...(isMobile ? {inset: "0px"} : {}),
        }
      }}
    >
      <div className="modal-header">
        <h5 className="modal-title">{title}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={props.onRequestClose}></button>
      </div>

      {props.children || (
      <>
        <div className="modal-body" style={{flex :1}}>
          {body}
        </div>

        <div className="modal-footer">
          {footer}
        </div>
      </>

      )}

    </ReactModal>
  )
}